import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { UtensilsCrossed } from "lucide-react";
import api from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ProductForm } from "@/components/journal/ProductForm";
import { isoToday, newEntryId, errorKey } from "@/lib/foodlog";

// « J'ai mangé ce repas » : ajoute une recette CHENIA au journal (quantité modifiable), hors programme ou depuis une fiche recette.
export function EatRecipeButton({ recipe, slot, portions = 1, memberId = "primary", size = "sm", className = "" }) {
  const { t, tv } = useLang();
  const qc = useQueryClient();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const cat = recipe.category || recipe.categories?.[0];
  const meal0 = ["breakfast", "lunch", "dinner", "snack"].includes(slot) ? slot : (["breakfast", "lunch", "dinner", "snack"].includes(cat) ? cat : "lunch");
  const [meal, setMeal] = useState(meal0);
  const name = typeof recipe.name === "string" ? recipe.name : tv(recipe.name);
  const add = async ({ quantity }) => {
    setBusy(true);
    try {
      await api.post("/food/entries", { entry_id: newEntryId(), date: isoToday(), member_id: memberId, meal, source: "recipe", ref_id: recipe.variant_of || recipe.id, quantity, unit: "portion" });
      toast.success(t("j_added")); qc.invalidateQueries({ queryKey: ["food-day"] }); qc.invalidateQueries({ queryKey: ["tracking"] }); setOpen(false);
    } catch (e) { toast.error(t(errorKey(e))); } finally { setBusy(false); }
  };
  return (
    <>
      <Button size={size} variant="outline" className={`rounded-full ${className}`} onClick={() => setOpen(true)} data-testid={`eat-recipe-${recipe.id}`}><UtensilsCrossed className="h-4 w-4 mr-1" />{t("j_eat_recipe")}</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-md rounded-3xl" data-testid="eat-recipe-dialog">
          <DialogHeader><DialogTitle>{t("j_eat_recipe")}</DialogTitle></DialogHeader>
          <ProductForm food={{ name, image: recipe.image, recipe: true, nutrition: recipe.nutrition }} meal={meal} onMeal={setMeal} onAdd={add} busy={busy} defaultQty={portions} />
        </DialogContent>
      </Dialog>
    </>
  );
}
